import { FeaturedItemsContent, FeaturedItemsContentComponentConfig, FeaturedItemsContentComponentModel, HawkSearchComponents } from '@models';
import { BaseContentComponent } from '../base-content.component';
import { FeaturedItemsContentItemComponent } from '../featured-items-content-item/featured-items-content-item.component';
import defaultHtml from './featured-items-content.component.hbs';

export class FeaturedItemsContentComponent extends BaseContentComponent<
    FeaturedItemsContentComponentConfig,
    FeaturedItemsContent,
    FeaturedItemsContentComponentModel
> {
    protected override componentName: keyof HawkSearchComponents = 'featured-items-content';
    protected override defaultHtml = defaultHtml;

    protected override renderContent(): boolean {
        return !!this.data?.items?.length;
    }

    protected override getContentModel(): FeaturedItemsContentComponentModel {
        return {
            ...this.data!
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelectorAll<FeaturedItemsContentItemComponent>('hawksearch-featured-items-content-item').forEach((component, index) => {
            component.data = this.data?.items?.[index];
        });
    }
}
